module.exports = __webpack_public_path__ + "static/img/solve1.5e9b202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solve1.png
// module id = eLhk
// module chunks = 0